import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { TwinClient as TwinClient0 } from "twin-client/src/client.js";
import config from "../../config.js";
import { useProfiles } from "../profiles.js";
import { TreasuryClient } from "./treasury-client.js";

export class TwinClient extends TwinClient0 {
  constructor({ url, apiKey, token }) {
    super({ url,  apiKey });
    this.token = token;
  }

  async request(config) { // make twin-client-js work with tokens
    let params = config.params || {};
    params = {
      ...params,
      host: this.host
    };

    let headers = config.headers || {};
    headers = {
      ...headers,
      ...this.token && { authorization: `${this.token.token_type} ${this.token.access_token }`}
    };

    return super.request({
      ...config,
      params,
      headers
    });
  }

  static getLatestTether(current) {
    if (!current) {
      current = "4172f9e82c0af9eff943d41ff7b7d8c40741aaba8a10e6f09ebb1c011650f11945"

      // ^^ we may want to update this every now and again
    }
    // NOTE: not using this.request because we're getting from relay.todaq.net
    // Ideally this should be RelayClient class
    return axios.get(`https://relay.todaq.net/api/ticket/${current}`)
      .then(res => res.data.itinerary[0].twist)

  }

  static async test(url) { // TODO(sfertman): change this to static info method -- I'm using this as info in some places
    return (new this({ url })).info();
  }

  static async persona(url) {
    return (new this({ url })).persona();
  }

  async address() {
    if (!this.twinAddress) {
      this.twinAddress = (await this.info()).address;
    }
    return this.twinAddress;
  }

  async persona() { // backport to stock js client
    return this.request({
      method: "GET",
      url: "/persona"
    });
  }

  async balance(typeHash) {
    if (typeHash) {
      return super.balance(typeHash);
    }
    return this.request({
      method: "GET",
      url: "/dq"
    });
  }


  verifyLink(h) {
    return `https://verify.todaq.net/#${encodeURIComponent(`${this.url}/toda/${h}?apiKey=${this.apiKey}`)}`;
  }

  analyzeLink(h) {
    return `https://trie.fun/analyzer/#${this.url}/toda/${h}?apiKey=${this.apiKey}`;
  }

  downloadLink(h) {
    return `${this.url}/toda/${h}?apiKey=${this.apiKey}`;
  }

}

export function getClient({client} = {}) {
    if (client) {
        return new TwinClient(client);
    }
}

export function getActiveClient() {
    const { getActiveProfile } = useProfiles();
    return getClient(getActiveProfile())
}

export function useBackendConfig() {
  let client = new TreasuryClient(); // config is unauthenticated
  let { data: treasuryConfig } = useQuery({
    queryKey: ["GET", config.backendUrl, "/"],
    queryFn: function getConfigFn() {
      return client.getConfig();
    }
  });
  return treasuryConfig;
}

/**
 *
 * @returns {TwinClient}
 */
export function useActiveClient() {
    let { active, getActiveProfile } = useProfiles();
    let client = useMemo(() => getClient(getActiveProfile()), [active]);
    return client;
}

export function useTreasuryClient() {
  let activeClient = useActiveClient();
  return TreasuryClient.from(activeClient);
}
